const htmlTemplates = {
  generateNewUniversalConfirmed: (data, generalInfo, formConfig) => {
    const dt = JSON.parse(JSON.stringify(data));
    const LoanID = dt?.loan_information?.loan_id || "";

    const confirmationDate = dt?.approval_history && dt.approval_history.length > 0 ? dt.approval_history[dt.approval_history.length - 1].date : null;

    const formatBoolean = (value) => {
      if (value === true) return "კი";
      if (value === false) return "არა";
      return "-";
    };

    const resolveIdToName = (value, options) => {
      if (typeof value === "object" && value !== null) {
        if (value.municipality) return String(value.municipality);
        if (value.name) return String(value.name);
        const idToFind = value._id;
        if (idToFind && options && Array.isArray(options)) {
          const found = options.find((opt) => opt.value === idToFind || opt._id === idToFind);
          if (found) return String(found.label || found.name);
        }
        return String(idToFind || "");
      }
      if (!value) return String(value ?? "");
      if (options && Array.isArray(options)) {
        const found = options.find((opt) => opt.value === value || opt._id === value);
        if (found) return String(found.label || found.name);
      }
      return String(value);
    };

    const formatFieldValue = (value, fieldConfig, generalInfo) => {
      if (value === undefined || value === null || value === "") return "-";
      if ((fieldConfig.type === "text" || fieldConfig.type === "textarea") && typeof value === "string") return value;
      if (fieldConfig.type === "number" && typeof value === "number") return value.toLocaleString ? value.toLocaleString() : value;

      switch (fieldConfig.type) {
        case "date":
          try {
            const date = new Date(value);
            return date.toLocaleDateString("ka-GE");
          } catch (e) {
            return "Invalid Date";
          }
        case "checkbox":
          return formatBoolean(value);
        case "select":
        case "autocomplete":
          let options = fieldConfig.options;
          if (typeof options === "function") {
            if (Array.isArray(value))
              return value.map((v) => (typeof v === "object" && v !== null ? String(v.name || v.municipality || v._id || "") : String(v))).join(", ");
            if (typeof value === "object" && value !== null) return String(value.municipality || value.name || value._id || "");
            return String(value);
          }
          if (Array.isArray(value)) return value.map((val) => resolveIdToName(val, options)).join(", ") || "-";
          return resolveIdToName(value, options);
        case "number":
          return typeof value === "number" && value.toLocaleString ? value.toLocaleString() : value;
        default:
          return String(value);
      }
    };

    const getValue = (obj, path) => {
      return path.split(".").reduce((current, key) => current && current[key], obj);
    };

    let dynamicContent = "";

    if (formConfig && formConfig.groups && formConfig.fields) {
      formConfig.groups.forEach((group) => {
        if (group.name.includes("approval") || group.name.includes("related_applications")) {
          return;
        }

        if (group.visibility && !group.visibility(dt, generalInfo)) {
          return;
        }

        const groupFields = formConfig.fields.filter((field) => field.group === group.name);
        const visibleFields = groupFields.filter((field) => !field.visibility || field.visibility(dt, generalInfo));

        if (visibleFields.length === 0) {
          return;
        }

        dynamicContent += `
          <tr class="group-header">
            <td colspan="2" style="background-color: #f5f5f5; font-weight: bold; text-align: center; padding: 10px;">
              ${group.label}
            </td>
          </tr>`;

        visibleFields.forEach((field) => {
          const value = getValue(dt, field.name);
          const formattedValue = formatFieldValue(value, field, generalInfo);

          dynamicContent += `
            <tr class="field-row">
              <td><b>${field.label}:</b></td>
              <td>${formattedValue}</td>
            </tr>`;
        });
      });
    }

    return {
      css: "",
      html: `
            <div>
            <style>
            @font-face {
                    font-family: 'Dejavu';
                    src: url('../../../assets/fonts/bpg_dejavu_sans.ttf') format('truetype');
                    font-weight: normal;
                    font-style: italic;
                }
            
            @media print {
              .page-break-before { page-break-before: always; }
              .page-break-after { page-break-after: always; }
              .no-page-break { page-break-inside: avoid; }
              
              /* Prevent table rows from breaking across pages */
              tr { page-break-inside: avoid; }
              
              /* Keep group headers with their content */
              .group-header { 
                page-break-after: avoid; 
                page-break-inside: avoid;
              }
              
              /* Ensure table sections stay together when possible */
              .table-section {
                page-break-inside: avoid;
                margin-bottom: 20px;
              }
            }
            
            #customers {
              font-family: Arial, Helvetica, sans-serif;
              width: 100%;
              border-collapse: collapse;
              page-break-inside: auto;
            }

            #customers td, #customers th {
              font-family: 'DejaVu', sans-serif;
              border: 1px solid #2C5B94;
              padding: 8px;
              page-break-inside: avoid;
            }
            
            table {
              font-size: 14px;
              color: black;
              font-family: 'DejaVu', sans-serif;
              border-spacing: 0;
              border-collapse: collapse;
              border: 1px solid #2C5B94;
              border-radius: 5px;
              page-break-inside: auto;
            }

            #customers tr:nth-child(odd){background-color: inherits;}

            #customers tr:hover {background-color: #2C5B94;}

            #customers th {
              padding-top: 12px;
              padding-bottom: 12px;
              text-align: left;
              background-color: #04AA6D;
              color: white;
            }
            
            .group-header {
              background-color: #f5f5f5 !important;
              font-weight: bold;
              text-align: center;
              padding: 10px;
              page-break-after: avoid;
              page-break-inside: avoid;
            }
            
            .field-row {
              page-break-inside: avoid;
            }
            
            .field-row:nth-child(n+3) {
              page-break-before: auto;
            }
            </style>
<h4 style="text-align:center; padding:0 70px;">სახელმწიფო პროგრამაში "ახალი უნივერსალური" დადასტურებული სესხის/ლიზინგის პროექტი</h4>
<br/>
<table id="customers">
  ${dynamicContent}
  ${
    confirmationDate
      ? `<tr>
    <td><b>სააგენტოში დადასტურების თარიღი:</b></td>
    <td>${new Date(confirmationDate).toLocaleDateString("ka-GE")}</td>
  </tr>`
      : ""
  }
  <tr>
    <td><b>განაცხადის სტატუსი:</b></td>
    <td>დადასტურებული</td>
  </tr>
</table >
<br />
<p style="font-family:none; font-size:14px; padding:5px; text-align:right">გავეცანი და ვეთანხმები სსიპ „აწარმოე საქართველოში" წარდგენილ და დადასტურებულ განაცხადს.</p>
</div >
  `,
    };
  },
  generateUniversalForBank: (data) => {
    const dt = JSON.parse(JSON.stringify(data));
    const LoanID = (dt?.refinancing_information ? dt?.refinancing_information?.loan_id : "") || (dt.loan_information ? dt.loan_information?.loan_id : "");
    return {
      css: "",
      html: `
            <div>
            <style>
            @font-face {
                    font-family: 'Dejavu';
                    src: url('../../../assets/fonts/bpg_dejavu_sans.ttf') format('truetype');
                    font-weight: normal;
                    font-style: italic;
                }
            #customers {
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
}

#customers td, #customers th {
  font-family: 'DejaVu', sans-serif;
  border: 1px solid #2C5B94;
  padding: 8px;
}
 table {
  font-size: 14px;
  color: black;
  font-family: 'DejaVu', sans-serif;
  border-spacing: 5px; /* Adds space between cell borders */
  border: 1px solid #2C5B94; /* Adds a border around the entire table */
  border-radius: 5px; /* Adds a little curve to the border */
}

#customers tr:nth-child(odd){background-color: inherits;}

#customers tr:hover {background-color: #2C5B94;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #04AA6D;
  color: white;
}
            </style>
<h4 style="text-align:center; padding:0 70px;">სახელმწიფო პროგრამაში "უნივერსალურ ინდუსტრიული ნაწილი" დადასტურებული სესხის/ლიზინგის პროექტი</h4>
<br/>
<table id="customers">
  <tr>
    <td><b>ბენეფიციარი:</b></td>
    <td>
      <div style="display:flex;flex-direction: column; gap:10px">
            <table style="border:1px solid #ddd;  border-radius:2px; border-collapse: collapse;">
                <tbody>
                  <tr>
                    <td  style="border:none; border-bottom:1px solid #ddd;">სამართლებრივი ფორმა:</td>
                    <td  style="border:none; border-bottom:1px solid #ddd; border-left:1px solid #ddd;">${
                      dt?.applicant_information?.legal_form?.name ? dt?.applicant_information?.legal_form?.name : ""
                    }</td>
                  </tr>
                  <tr>
                    <td  style="border:none; border-bottom:1px solid #ddd;">დასახელება:</td>
                    <td  style="border:none; border-bottom:1px solid #ddd; border-left:1px solid #ddd;">${
                      dt?.applicant_information?.name ? dt?.applicant_information?.name : ""
                    }</td>
                  </tr>
                  <tr>
                    <td  style="border:none; border-bottom:1px solid #ddd;">საიდენტიფიკაციო კოდი:</td>
                    <td  style="border:none; border-bottom:1px solid #ddd; border-left:1px solid #ddd;">${
                      dt?.applicant_information?.identification_code ? dt?.applicant_information?.identification_code : ""
                    }</td>
                  </tr>
                </tbody>
        </table>
      </div>
    </td>
  </tr>
  <tr>
    <td><b>სესხის/ლიზინგის ID:</b></td>
    <td>${LoanID}</td>
  </tr>
  <tr>
    <td><b>კომპონენტი:</b></td>
    <td>${dt.program_type?.name}</td>
  </tr>
  <tr>
    <td><b>საკრედიტო საგარანტიო სქემით სარგებლობა:</b></td>
    <td>${dt.credit_guarantee_scheme ? "მონიშნულია" : "არ არის მონიშნული"}</td>
  </tr >
  <tr>
  <td><b>თანხა-₾:</b></td>
  <td>${dt?.loan_information?.conditions?.approved_amount?.toLocaleString()}</td>
</tr>
  <tr>
    <td><b>სესხის/ლიზინგის მიზნობრიობა დეტალურად:</b></td>
    <td>${dt.loan_information?.conditions?.purpose?.purpose_detailed}</td>
  </tr>
  <tr>
    <td><b>პროექტის ეკონომიკური აქტივობა:</b></td>
    <td>
        <div style="display:flex;flex-direction: column; gap:10px">
            ${dt.project_information?.economic_activity.map(
              (activity) => `<table style="border:1px solid #ddd;  border-radius:2px; border-collapse: collapse;">
                <tbody>
                    <tr>
                      <td style="border:none; border-bottom:1px solid #ddd;">კოდი:</td>
                      <td style="border:none; border-bottom:1px solid #ddd; border-left:1px solid #ddd;">${activity.activity_code}</td>
                    <tr>
                    <tr>
                      <td style="border:none; border-bottom:1px solid #ddd;">აღწერა:</td>
                      <td style="border:none; border-bottom:1px solid #ddd; border-left:1px solid #ddd;">${activity.activity_description}</td>
                    <tr>
                </tbody>
            </table>`
            )}
        </div>
    </td>
  </tr>
  <tr>
    <td><b>საქმიანობა ჯდება 15%-იან გრანტში:</b></td>
    <td>${dt.project_information?.economic_activity.some((activity) => activity.appendix_9 === true) ? "აკმაყოფილებს" : "არ აკმაყოფილებს"}</td>
  </tr>
        <tr>
    <td><b>პროექტის განხორციელების ფაქტობრივი მისამართი:</b></td>
    <td>${dt.project_information?.actual_address?.street}</td>
  </tr>
    <tr>
      <td><b>პროექტის საკადასტრო კოდი:</b></td>
    <td>${dt.project_information?.actual_address?.cadastral_code}</td>
  </tr>
</table >
<br />
<p style="font-family:none; font-size:14px; padding:5px; text-align:right">გავეცანი და ვეთანხმები სსიპ „აწარმოე საქართველოში“ წარდგენილ და დადასტურებულ განაცხადს.</p>
</div >
  `,
    };
  },
  generateMortgageForBank: (data) => {
    const dt = JSON.parse(JSON.stringify(data));
    const LoanID = (dt?.refinancing_information ? dt?.refinancing_information?.loan_id : "") || (dt?.loan_information ? dt?.loan_information?.loan_id : "");

    return {
      csss: "",
      html: `
            <div>
            <style>
            @font-face {
                    font-family: 'Dejavu';
                    src: url('../../../assets/fonts/bpg_dejavu_sans.ttf') format('truetype');
                    font-weight: normal;
                    font-style: italic;
                }
            #customers {
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
}

#customers td, #customers th {
  font-family: 'DejaVu', sans-serif;
  border: 1px solid #2C5B94;
  padding: 8px;
}
 table {
  font-size: 14px;
  color: black;
  font-family: 'DejaVu', sans-serif;
  border-spacing: 5px; /* Adds space between cell borders */
  border: 1px solid #2C5B94; /* Adds a border around the entire table */
  border-radius: 5px; /* Adds a little curve to the border */
}

#customers tr:nth-child(odd){background-color: inherits;}

#customers tr:hover {background-color: #2C5B94;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #04AA6D;
  color: white;
}
            </style>
<h4 style="text-align:center; padding:0 70px;">იპოთეკური სესხების სუბსიდირების სახელმწიფო პროგრამაში დადასტურებული სესხის განაცხადი</h4>
<br/>
<table id="customers">
                  <tr>
                    <td>მსესხებლის სახელი, გვარი:</td>
                    <td>${dt?.borrower_information?.borrower?.name ? dt?.borrower_information?.borrower?.name : ""}</td>
                  </tr>
                  <tr>
                    <td>მსესხებლის პირადი ნომერი:</td>
                    <td>${dt?.borrower_information?.borrower?.private_number ? dt?.borrower_information?.borrower?.private_number : ""}</td>
                  </tr>
                  
                  ${
                    dt?.borrower_information?.borrower_spouse?.name
                      ? `<tr>
                    <td>მსესხებლის მეუღლის სახელი, გვარი:</td>
                    <td>${dt?.borrower_information?.borrower_spouse?.name}</td>
                  </tr> `
                      : ""
                  }
                  ${
                    dt?.borrower_information?.borrower_spouse?.private_number
                      ? `<tr>
      <td>მსესხებლის მეუღლის პირადი ნომერი:</td>
      <td>${dt?.borrower_information?.borrower_spouse?.private_number}</td>
    </tr> `
                      : ""
                  }
    
                  <tr>
                    <td>ფინანსური ინსტიტუტი:</td>
                    <td>${dt?.bank.name ? dt?.bank.name : ""}</td>
                  </tr>
                  <tr>
                    <td>სესხის ID:</td>
                    <td>${LoanID}</td>
                  </tr>
                  <tr>
                    <td>სესხის მიზნობრიობა:</td>
                    <td>${dt?.purpose?.name ? dt?.purpose?.name : ""}</td>
                  </tr>
                   <tr>
                    <td>სესხის ტიპი:</td>
                    <td>${dt?.application_type ? dt?.application_type?.name : ""}</td>
                  </tr>
                  <tr>
                    <td>სესხის თანხა:</td>
                    <td>${dt?.loan_information?.amount ? dt?.loan_information?.amount?.toLocaleString() : ""}</td>
                  </tr>
                  <tr>
                    <td>სესხის ვადა (თვე):</td>
                    <td>${dt?.loan_information?.duration ? dt?.loan_information?.duration : ""}</td>
                  </tr>
                  <tr>
                    <td>სესხის პროცენტის თანადაფინანსების ვადა (თვე):</td>
                    <td>${dt?.loan_information?.subsidy_duration_months ? dt?.loan_information?.subsidy_duration_months : ""}</td>
                  </tr>
                  <tr>
                    <td>ბავშვების რაოდენობა:</td>
                    <td>${dt?.children_information?.length ? dt?.children_information?.length : ""}</td>
                  </tr>
                  <tr>
                    <td>შესაძენი/ასაშენებელი ქონების ზუსტი მისამართი:</td>
                    <td>${dt?.home_information?.exact_address ? dt?.home_information?.exact_address : ""}</td>
                  </tr>
                  <tr>
                    <td>შესაძენი/ასაშენებელი ქონების საკადასტრო კოდი:</td>
                    <td>${dt?.home_information?.cadastral_code ? dt?.home_information?.cadastral_code : ""}</td>
                  </tr>
</table >
<br />
<p style="font-family:none; font-size:14px; padding:5px; text-align:right">გავეცანი და  ვეთანხმები კომერციული ბანკის მიერ სსიპ „აწარმოე საქართველოში“ წარდგენილ და დადასტურებულ სესხის განაცხადს.</p>
</div >
  `,
    };
  },
};

export default htmlTemplates;
